"use client";

import React from "react";
import Image from "next/image";
import EventDateTime from "./EventDateTime";
import CairaEventForm from "@/components/forms/CairaEventForm";
import { EventName, EventTypeEnum, FormHeading } from "@/interface/types";

interface CairaEventBannerProps {
  data: {
    bannerTitle: string;
    bannerData: {
      bannerAlt: string;
      bannerUrl: string;
    };
    eventDateAndTime: {
      date: string;
      time: string;
    };
    formLink: string | null;
    statisticsStrip: {
      duration: string;
      found_it_useful: string;
      learners: string;
    };
  };
  eventMetaData: {
    city: string;
    city_id: number;
    courseId: number;
    courseName: string;
    eventId: string;
    eventName: string;
    eventType: string;
    orientation_id: number;
    zoomWebinarId: string;
  };
}

const PagesBannerNewDesk: React.FC<CairaEventBannerProps> = ({
  data,
  eventMetaData,
}) => {
  let {
    courseId,
    eventId,
    eventName,
    eventType,
    city_id,
    city,
    courseName,
    orientation_id,
  } = eventMetaData;
  let { date, time } = data.eventDateAndTime;

  const isOffline = eventType === EventTypeEnum.OFFLINE;

  return (
    <>
      <div className="md:block hidden mx-auto w-full 2xl:h-[700px] md:h-[700px] h-[95vh] xl:px-0 md:px-6 lg:!px-6 px-5 relative md:pb-0 pb-[0px]">
        {/* Background Image with Blur Effect */}
        <div className="absolute inset-0 z-0">
          <Image
            src={data.bannerData.bannerUrl}
            alt={data.bannerData.bannerAlt || "Background"}
            className="w-full h-full object-cover"
            fill
            priority
            sizes="100vw"
          />
          {/* Blur Overlay */}
          <div
            className="absolute inset-0"
            style={{
              background: "rgba(4, 16, 28, 0.12)",
              backdropFilter: "blur(50px)",
              WebkitBackdropFilter: "blur(50px)",
            }}
          />
        </div>

        <Image
          src={"/events/frame-desk.png"}
          alt="events"
          className="absolute top-[84%] bottom-0 right-0 left-[100px] w-[609px] z-10 pointer-events-none"
          width={609}
          height={200}
          priority
        />

        <div className="absolute 2xl:bottom-[50px] 2xl:left-[6%] md:bottom-[50px] md:left-[8%]">
          <EventDateTime
            date={data.eventDateAndTime?.date}
            time={data.eventDateAndTime?.time}
          />
        </div>
        <div className="absolute top-[86%] left-[100px] w-[609px] h-[200px] z-20 flex justify-between items-center px-6 pointer-events-none">
          <div className="flex-1 text-center">
            <h3 className="text-[24px] font-bold text-[#030F1C]">
              {data.statisticsStrip.learners}
            </h3>
            <p className="text-sm text-[#6B7280]">Learners</p>
          </div>

          <div className="w-px h-[50px]"></div>

          <div className="flex-1 text-center">
            <h3 className="text-[24px] font-bold text-[#030F1C]">
              {data.statisticsStrip.duration}
            </h3>
            <p className="text-sm text-[#6B7280]">Duration (mins)</p>
          </div>

          <div className="w-px h-[50px]"></div>

          <div className="flex-1 text-center">
            <h3 className="text-[24px] font-bold text-[#030F1C]">
              {data.statisticsStrip.found_it_useful}
            </h3>
            <p className="text-sm text-[#6B7280]">Found It Useful</p>
          </div>
        </div>

        <div className="absolute top-0 left-0 w-full h-full flex flex-col md:flex-row justify-between items-center px-8 md:px-16 lg:px-32 z-20">
          <div className="w-full md:w-1/2 flex justify-center items-center relative z-30 pointer-events-auto">
            <Image
              src={data.bannerData.bannerUrl}
              alt={data.bannerData.bannerAlt || "Event Banner Image"}
              className="max-w-full h-auto rounded-lg shadow-lg"
              width={600}
              height={400}
              priority
            />
          </div>

          {data.formLink && (
            <div
              className="p-6 w-full md:w-[400px] rounded-2xl border"
              style={{
                background: "rgba(6, 26, 47, 0.85)",
                boxShadow: "0 0 54.9px 0 rgba(166, 137, 255, 0.40) inset",
                borderColor: "rgba(255, 255, 255, 0.15)",
                backdropFilter: "blur(12px)",
              }}
            >
              <CairaEventForm
                isOfflineFrom={isOffline}
                cityId={city_id}
                courseId={courseId}
                eventId={eventId}
                cityName={city}
                courseName={courseName}
                eventName={eventName}
                eventType={EventName.CAIRA}
                formHeading={FormHeading.JOIN_US_LIVE_WITH_VARUN_JAIN}
                eventDate={date}
                eventTime={time}
                submitButtonName="Apply Now"
                orientationId={orientation_id}
                isDarkBackground
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default PagesBannerNewDesk;
